import {NgModule} from '@angular/core';
import {SyncDataComponent} from './sync-data.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BzTabModule} from '../shared/components/tab/tab.module';
import {ImportStep0Component} from './import/import-step0/import-step0.component';
import {ImportStep10Component} from './import/import-step10/import-step10.component';
import {ImportStep20Component} from './import/import-step20/import-step20.component';
import {ImportStep30Component } from './import/import-step30/import-step30.component';
import {ExportStep10Component} from './export/export-step10/export-step10.component';
import {ExportStep30Component} from './export/export-step30/export-step30.component';
import {ExportStep40Component} from './export/export-step40/export-step40.component';
import {SharedModule} from './../shared/shared.module';
import {FormsModule} from '@angular/forms';
import {BzgButtonModule, BzgModalModule} from 'bz-genome-angular';
import {SyncDataImportComponent} from './import/sync-data-import.component';
import {BrowserModule} from '@angular/platform-browser';
import {MatTabsModule} from '@angular/material/tabs';
import {SyncDataExportComponent} from './export/sync-data-export.component';
import { ExportHistoryTableComponent } from './export/export-history-table/export-history-table.component';
import { ImportHistoryTableComponent } from './import/import-history-table/import-history-table.component';
import { ImportStep40Component } from './import/import-step40/import-step40.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}



@NgModule({
  declarations: [
    SyncDataComponent,
    SyncDataImportComponent,
    ImportStep0Component,
    ImportStep10Component,
    ImportStep20Component,
    ImportStep30Component,
    SyncDataExportComponent,
    ExportStep10Component,
    ExportStep30Component,
    ExportStep40Component,
    ExportHistoryTableComponent,
    ImportHistoryTableComponent,
    ImportStep40Component
  ],
  imports: [
    MatTabsModule,
    BzgButtonModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BzTabModule,
    SharedModule,
    FormsModule,  
    BzgModalModule
  ]
})
export class SyncDataModule { }
